module.exports = __webpack_public_path__ + "img/la_tene_map.322cb451.png";